import React, { useState } from 'react'
import { Text } from '@mantine/core'
import ScratchRecordModal from '../ScratchCard/components/ScratchRecordModal'

const ACTIVITY_END_AT = '2026-02-28T23:59:59+08:00'
const ENDED_AT_LABEL = new Intl.DateTimeFormat('zh-CN', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'Asia/Shanghai',
}).format(new Date(ACTIVITY_END_AT))

interface ActivityEndedViewProps {
  customerServiceUrl?: string
}

const ActivityEndedView: React.FC<ActivityEndedViewProps> = ({ customerServiceUrl }) => {
  const [recordModalOpen, setRecordModalOpen] = useState(false)

  return (
    <>
      <div
        data-testid="activity-ended-view"
        style={{
          borderRadius: 20,
          padding: '24px 18px',
          background: '#FFFCF7',
          border: '1px solid #E9DECF',
          boxShadow: '0 6px 18px rgba(105, 79, 49, 0.06)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px 12px',
            borderRadius: 999,
            background: '#F4ECE1',
            color: '#7C5834',
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          活动已结束
        </div>

        <Text
          style={{
            marginTop: 14,
            color: '#2F2418',
            fontSize: 24,
            fontWeight: 800,
            lineHeight: 1.35,
            textAlign: 'center',
          }}
        >
          抽奖活动已于 {ENDED_AT_LABEL} 结束
        </Text>
        <Text
          style={{
            marginTop: 8,
            color: '#6F6252',
            fontSize: 14,
            lineHeight: 1.6,
            textAlign: 'center',
          }}
        >
          可通过下方入口查看抽奖记录或联系客服。
        </Text>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            marginTop: 20,
            justifyContent: 'center',
          }}
        >
          <button
            type="button"
            onClick={() => setRecordModalOpen(true)}
            style={{
              flex: '1 1 180px',
              minHeight: 44,
              border: '1px solid #5B4330',
              borderRadius: 14,
              background: '#5B4330',
              color: '#FFFDF9',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            查看抽奖记录
          </button>
          {customerServiceUrl && (
            <a
              href={customerServiceUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                flex: '1 1 180px',
                minHeight: 44,
                border: '1px solid #D6C6B3',
                borderRadius: 14,
                background: '#FFFFFF',
                color: '#5B4330',
                fontSize: 15,
                fontWeight: 700,
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              联系客服
            </a>
          )}
        </div>
      </div>

      <ScratchRecordModal opened={recordModalOpen} onClose={() => setRecordModalOpen(false)} />
    </>
  )
}

export default ActivityEndedView
